/*
 * @Description:
 * @LastEditTime: 2023-03-15 15:37:58
 * @LastEditors: 何俊峰
 * @Author: 何俊峰
 * @Date: 2023-03-15 14:05:06
 */
export default {
  route: {
    dashboard: "主页",
    introduction: "简述",
    documentation: "文档",
    guide: "系统管理",
    guide1: "系统用户",
    guide2: "角色管理",
    guide3: "区域管理",
    errorPages: "错误页面",
    page401: "401",
    page404: "404",
    handle: "处理",
    errorLog: "错误日志",
    permission: "权限测试页",
    pagePermission: "页面权限",
    directivePermission: "指令权限",
    service: "服务管理",
    service1: "用户管理",
    service2: "服务对象管理",
    service3: "服务记录",
    service4: "服务类目",
    service45: "服务项目",
    customerLog: "待处理服务",
    service5: "详情",
    details: "详情",
    restore: "回收站",
    recycle: "回收站",
    increase: "新增",
    delete: "删除",
    reset: "重置",
    edit: "编辑",
    query: "查询",
    personal: "个人中心",
    export: "导出",
    customerExport: "导出服务对象",
    notice: "通知",
    customer: "服务对象",
    record: "服务记录",
    reduction: "还原",
    allocation: "批量分配",
    inport: "导入",
    customerInport: "导入服务对象",
    allocation: "批量分配",
    project: "服务项目",
    download: "模板下载",
    callRecords: "通话记录",
    operate: "运营管理",
    activity: "活动管理",
    news: "资讯管理",
    notice: "通知管理",
    activityAdd: "活动新增",
    enrollList: "报名详情",
    editEnroll: "编辑报名",
    exportEnroll: "导出PDF",
    recruit: "招聘管理",
    recruitAdd: "新增招聘",
    applicants: "招聘情况",
    volunteers: "志愿者",
    company: "企业管理",
    verify: "审核",
    auth: "企业认证",
    print: "智能打印",
    message: "消息管理",
    editDelivery: "编辑录用",
    projectQuery: "项目查询",
    projectIncrease: "新增项目",
    projectEdit: "编辑项目",
    projectDelete: "删除项目",
    exportDelivery: "导出PDF",
    replayComment: "回复评价",
    callLogDelete: "电话探访记录删除",
    callLogExport: "电话探访记录导出",
    preCheckPass: "预审合格",
    checkPass: "合格",
    checkUnPass: "不合格",
    endCheckUnPass: "终审不合格",
    onlineLogDelete: "线上服务删除",
    offlineLogDelete: "线下服务删除",
    offlineLogComment: "线下服务评分",
  },
  login: {
    title: "系统登录",
    logIn: "登录",
    username: "账号",
    password: "密码",
    title1: "康顺分散供养人员照料护理服务指挥调度中心",
    password1: "记住密码",
    name: "请输入正确的账号",
    pass: "密码不能小于6位",
  },
  navbar: {
    logOut: "退出登录",
    logOut1: "个人中心",
    dashboard: "首页",
    github: "项目地址",
    theme: "换肤",
    size: "字体大小",
  },
  guide: {
    description:
      "引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于",
    button: "打开引导",
  },
  tagsView: {
    refresh: "刷新",
    close: "关闭",
    closeOthers: "关闭其它",
    closeAll: "关闭所有",
  },
  permission: {
    roles: "你的权限",
    switchRoles: "切换权限",
    tips: "在某些情况下，不适合使用 v-permission。例如：Element-UI 的 Tab 组件或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。",
  },
};
